import { useParams } from "react-router-dom";
import {
  IGlobalPeriodContext,
  useReportBespoke,
  useSnapshot,
} from "@iliotech/data-wire";
import { EnabledColumnMap, IllioTable } from "src/main";
import React from "react";

const DEFAULT_COLUMNS = Object.fromEntries(
  IllioTable.ColumnSets.TransactionsPage.filter(
    (column) => column.isDefault
  ).map((col) => [col.field, { enabled: true, order: col.order || 1000 }])
);

export const useTransactionsWidget = (cellId: string, pageId: string) => {
  const store = useReportBespoke();
  const allColumns = IllioTable.ColumnSets.TransactionsPage;

  const columnSettings: EnabledColumnMap =
    store.pages[pageId].cells[cellId].extraOptions
      ?.transactionsWidgetSettings || DEFAULT_COLUMNS;

  const setColumnSettings = (preferences: any) => {
    store.updateCell(pageId, cellId, "extraOptions", {
      ...store.pages[pageId].cells[cellId].extraOptions,
      transactionsWidgetSettings: preferences,
    });
  };
  const columns = React.useMemo(() => {
    return allColumns
      .filter((column) => columnSettings[column.field]?.enabled)
      .sort((a, b) => (a.order || 900) - (b.order || 900))
      .sort(
        (a, b) =>
          (columnSettings[a.field]?.order ?? (a.order || 900)) -
          (columnSettings[b.field]?.order ?? (b.order || 900))
      );
  }, [columnSettings]);

  return { columnSettings, setColumnSettings, columns, allColumns };
};
